module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "textSection"
  }, [_c('h1', [_vm._v("Questionnaire : SUJET")]), _vm._v(" "), _c('p', [_vm._v("instructions d'utilisation")]), _vm._v(" "), _c('form', [_c('fieldset', [_c('legend', [_vm._v("Question numéro X")]), _vm._v(" "), _c('p', [_vm._v("Intitulé de la question ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "name": "reponseA",
      "id": "answer"
    }
  }), _vm._v(" :  "), _c('label', {
    attrs: {
      "for": "answer"
    }
  }, [_vm._v("reponse")])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Valider"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "reset",
      "value": "Réinitialiser"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9667f0c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 454
// module chunks = 1